export type ActiveStatus = 'Active' | 'Inactive';

export interface CaseType {
  id: string;
  name: string;
  description: string;
  status: ActiveStatus;
}

export type AgencyType = 'Police' | 'Government' | 'Security' | 'Other';

export interface Agency {
  id: string;
  name: string;
  type: AgencyType;
  status: ActiveStatus;
}

export const AGENCY_TYPES: AgencyType[] = ['Police', 'Government', 'Security', 'Other'];
